// extracted by mini-css-extract-plugin
export var calculatorImage = "StaffAugmentation-module--calculator-image--3b979";
export var content = "StaffAugmentation-module--content--87a9b";
export var imageBox = "StaffAugmentation-module--image-box--ae14a";